function isEmpty(obj) {
    if (obj == null || typeof obj == typeof undefined) {
      return true
    }
    if (obj.length > 0) {
      return false
    }
    if (obj.length === 0) {
      return true
    }
    return true
  }
  function trim(text) {
    // var result = text.replace(new RegExp('\r?\n', 'g'), "");
    return text
  }
  function getFullAddress(addressInfo) {
    var address = ''
    if (!isEmpty(addressInfo.Province)) {
      address += addressInfo.Province
    }
    if (!isEmpty(addressInfo.City)) {
      address += addressInfo.City
    }
    if (!isEmpty(addressInfo.Area)) {
      address += addressInfo.Area
    }
    if (!isEmpty(addressInfo.Street)) {
      address += addressInfo.Street
    }
    if (!isEmpty(addressInfo.Address)) {
      address += addressInfo.Address
    }
    return address
  }
  function isAddressLegal(region) {
    if (typeof region === typeof undefined || region === null) {
      return false
    }
    if (region.length < 3) {
      return false
    }
    var isLegal = true
    for (var i = 0; i < region.length; i++) {
      if (
        typeof region[i] === typeof undefined ||
        region[i] == null ||
        region[i] == ''
      ) {
        isLegal = false
      }
    }
    return isLegal
  }
  function getDisplayPhoneNumber(phoneNumber) {
    if (phoneNumber && phoneNumber.length > 7) {
      return phoneNumber.substring(0, 3) + '****' + phoneNumber.substring(7)
    }
    return phoneNumber
  }
  function getDisplayEmail(email) {
    if (email) {
      var name = email.substring(0, email.indexOf('@'))
      var domain = email.substring(email.indexOf('@'))
      if (name.length > 3) {
        name = name.substring(0, 3)
      } else {
        name = name.substring(0, 1)
      }
      return name + '****' + domain
    }
    return email
  }
  function round(num, lengthAfterPoint) {
    var temp = Math.pow(10, lengthAfterPoint)
    return Math.round(num * temp) / temp
  }
  function getDisplayAddress(addrss) {
    var result = ''
    addrss.forEach(function (item, index, attr) {
      if (typeof item !== typeof undefined && item != null) {
        result += item
      }
    })
    return result
  }
  const tool =  {
    isEmpty: isEmpty,
    getFullAddress: getFullAddress,
    isAddressLegal: isAddressLegal,
    getDisplayPhoneNumber: getDisplayPhoneNumber,
    getDisplayEmail: getDisplayEmail,
    round: round,
    trim: trim,
    getDisplayAddress:getDisplayAddress
  }
  
  module.exports = tool